import dayjs from "dayjs";
import {
  IS_SEATS_REQUEST,
  IS_SELECTED_SEATS,
  IS_SELECTED_SERVICES,
  INITIAL_SALE_EVENT_CONTEXT,
} from "../../../constants";
import { ANC_BY_ID } from "../../../constants/anc-by-id";
import {
  _calculateTotalAmountAndQuantity,
  _createVariantSeatsString,
  _createVariantString,
  _mergeCoutingObjects,
} from "../misc-utils";
import { Ecommerce, EventParams, Item, PurchaseDto } from "./purchase.dto";
import { RegistryDto } from "../../services/registry.dto";
import { validateSessionByCookie } from "../../services/cookies";
import { isSelectedSeatsCookie } from "../../../dto/is-selected-seats.dto";


export const handlePurchaseEvent = (registry: RegistryDto): PurchaseDto => {
  const {
    env: environment,
    isApp: app,
    isCorpo: corp,
  } = JSON.parse(localStorage.getItem(INITIAL_SALE_EVENT_CONTEXT) || "{}");

  const iSSeatsRequest = JSON.parse(
    window.localStorage.getItem(IS_SEATS_REQUEST) ?? "{}"
  ) as any;

  const selectedSeats = JSON.parse(
    window.localStorage.getItem(IS_SELECTED_SEATS) ?? "[]"
  ) as isSelectedSeatsCookie[];

  const selectedServices: { ancillaryType: string; passengers: any[] }[] =
    JSON.parse(window.localStorage.getItem(IS_SELECTED_SERVICES) ?? "[]") as {
      ancillaryType: string;
      passengers: any[];
    }[];

  const { queryParams } = JSON.parse(
    window.localStorage.getItem("Origin") ?? "false"
  ) ?? {};

  const fullTrip = [];
  const fullTripDates = [];
  const fullTripTimes = [];

  registry.itineraryParts.map((flight) => {
    flight.segments.map((segment) => {
      fullTripDates.push(dayjs(segment.departure).format("YYYY-MM-DD"));
      fullTrip.push(`${segment.origin}-${segment.destination}`);
      fullTripTimes.push(
        `${dayjs(segment.arrival).format("hh:mm")}(${segment.origin})|${dayjs(
          segment.departure
        ).format("hh:mm")}(${segment.destination})`
      );
    });
  });

  const bundleInfoGoingReturn = registry.itineraryParts.map((flight) => {
    return flight.segments[0].fareBasis;
  });

  const bagsServices = selectedServices.filter(
    (service) => service.ancillaryType === "luggage"
  );
  const carryOnServices = selectedServices.filter(
    (service) => service.ancillaryType === "carry"
  );

  const countBagsServices = bagsServices.reduce((acc, service) => {
    return acc + service.passengers.length;
  }, 0);

  const countCarryOnServices = carryOnServices.reduce((acc, service) => {
    return acc + service.passengers.length;
  }, 0);

  const { paymentDetails, referenceCodes } = registry;
  const { paymentsDetails } = paymentDetails;

  const [pnrData] = referenceCodes ?? [];
  const methods = paymentsDetails?.map((payment) => payment.method) ?? [];
  const transactionIds =
    paymentsDetails?.map((payment) => payment.transactionId) ?? [];

  const page_path = window.location.pathname;
  const micrositio = corp ? "corporativo" : "booking";
  const page_type = "Confirmation";
  const negocio = "retail";
  const login = validateSessionByCookie() || corp;
  const homemarket = window.location.pathname.split("/")[2];
  const currency = iSSeatsRequest?.context?.currency ?? registry.currency ?? "CLP";
  const count_seats = selectedSeats.length;
  const count_bags = countBagsServices;
  const count_carry_on = countCarryOnServices;
  const initial_date = queryParams?.departureDate;
  const end_date = queryParams?.arrivalDate;
  const from_iata = queryParams?.origin;
  const to_iata = queryParams?.destination;
  const trip_type = queryParams?.flightType === "RT" ? "roundtrip" : "oneway";
  const time = fullTripTimes.join(",");
  const full_trip = fullTrip.join();
  const full_trip_dates = fullTripDates.join();
  const full_trip_fare_basis_full_trip_fare_basis =
    queryParams?.flightType === "RT"
      ? `${bundleInfoGoingReturn[0]}|${bundleInfoGoingReturn[1]}`
      : `${bundleInfoGoingReturn[0]}`;
  const bundle =
    queryParams?.flightType === "RT"
      ? `${bundleInfoGoingReturn[0].substring(
          1
        )}|${bundleInfoGoingReturn[1].substring(1)}`
      : `${bundleInfoGoingReturn[0].substring(1)}`;
  const passengers_adult = parseInt(queryParams?.ADT);
  const passengers_child = queryParams?.CHD ? parseInt(queryParams.CHD) : 0;
  const passengers_infant = queryParams?.INF ? parseInt(queryParams.INF) : 0;
  const passengers_pet = queryParams?.PET ? parseInt(queryParams.PET) : 0;
  const pax =
    parseInt(queryParams?.ADT || "0") +
    parseInt(queryParams?.CHD || "0") +
    parseInt(queryParams?.INF || "0");

  if (
    !window.location.href.match(/\/reservation\/([^/]+)$/) ||
    !window.location.href.match(/\/reservation\/([^/]+)$/)[1]
  ) {
    throw new Error("not orderId obtained");
  }
  const orderId = window.location.href.match(/\/reservation\/([^/]+)$/)[1];
  const purchaseParams: EventParams = {
    pnr: pnrData.value,
    register_id: orderId,
    payment_method: methods.join(", "),
    exchange_rate: "",
    buy_instance: "IS",
    environment,
    corp,
    app,
    page_path,
    micrositio,
    page_type,
    negocio,
    login,
    homemarket,
    currency,
    count_seats,
    count_bags,
    count_carry_on,
    initial_date,
    end_date,
    from_iata,
    to_iata,
    trip_type,
    time,
    full_trip,
    full_trip_dates,
    full_trip_fare_basis: full_trip_fare_basis_full_trip_fare_basis,
    fare_basis: full_trip_fare_basis_full_trip_fare_basis,
    bundle,
    passengers_adult,
    passengers_child,
    passengers_infant,
    passengers_pet,
    pax,
  };

  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const affiliation = `Sky | ${capitalizeFirstLetter(homemarket)}`;
  const ecommerce: Ecommerce = {
    transaction_id: transactionIds.join(", "),
    affiliation,
    tax: paymentDetails.taxesAmount,
    currency,
    value: paymentDetails.totalAmount - paymentDetails.taxesAmount,
    items: handleITemsPurchase(
      registry,
      passengers_adult + passengers_child,
      selectedSeats
    ).map((item, index) => ({
      ...item,
      index: index + 1,
    })),
  };

  return {
    event: "purchase",
    event_params: purchaseParams,
    ecommerce,
  };
};

const getDateFlight = (isReturning: boolean) => {
  const searchValues = localStorage.getItem("searchFlightValues");
  if(searchValues){
    const searchValuesParsed = JSON.parse(searchValues);
    return isReturning ? searchValuesParsed.departureDate : searchValuesParsed.arrivalDate;
  }
  return null;
}

const handleITemsPurchase = (
  registry: RegistryDto,
  paxQty: number,
  seatsSelected: isSelectedSeatsCookie[]
): Item[] => {
  const { additionalServices, itineraryParts } = registry;
  let additionalServicesTemp = additionalServices;
  if (!additionalServicesTemp) {
    additionalServicesTemp = {
      seatOperations: [],
      ancillaryOperations: [],
    };
  }
  if (!additionalServicesTemp.ancillaryOperations)
    additionalServicesTemp.ancillaryOperations = [];
  if (!additionalServicesTemp.seatOperations)
    additionalServicesTemp.seatOperations = [];

  let indexing = 0;
  const origin = itineraryParts[0].segments[0].origin;
  const destination =
    itineraryParts[0].segments[itineraryParts[0].segments.length - 1]
      .destination;
  const originDestination = `${origin}${destination}`;

  const tickets = itineraryParts.map((flight) => {
    const isReturning = flight.segments[0].origin === origin;
    const bundlesWithFlightNumber = flight.segments
      .map(
        (segment) =>
          `${segment.fareBasis.substring(0, 5)} - ${
            segment.flight.flightNumber
          }`
      )
      .join("|");
    const bundle = flight.segments.map(
      (segment) => `${segment.fareBasis.substring(1, 5)}`
    )[0];

    return {
      item_id: `${originDestination} | ${bundle}`,
      item_name: "Ticket",
      item_category: `Tickets|${isReturning ? "ida" : "vuelta"}`,
      item_list_name: "Tickets | IS",
      item_variant: bundlesWithFlightNumber,
      index: indexing,
      price: flight.fare,
      quantity: paxQty,
      cabin: "economy",
      date: getDateFlight(isReturning),
    };
  });

  const seats = itineraryParts.map((flight) => {
    const isReturning = flight.segments[0].origin === origin;

    const seats = [];
    const objVar = {};

    for (const seat of additionalServicesTemp?.seatOperations) {
      for (const segment of flight.segments) {
        objVar[segment.flight.flightNumber] =
          objVar[segment.flight.flightNumber] || [];
        if (
          seat.selectedSegment.origin === segment.origin &&
          seat.selectedSegment.destination === segment.destination &&
          seat.seatInf.amount > 0
        ) {
          seats.push(seat);
          const seatCode = seat.seatCode;
          const seatCookie = seatsSelected.find(
            (seat) => seat.seatCode === seatCode
          );
          objVar[segment.flight.flightNumber].push(seatCookie?.subCode ?? "");
        }
      }
    }
    const totalSeatsPrice = seats.reduce((acc, seat) => acc + seat.seatInf.amount, 0);
    const promPricePerItem = seats.length > 0 ? totalSeatsPrice / seats.length : 0;

    return {
      item_id: `${originDestination} | Asientos`,
      item_name: "Asientos",
      item_category: `Asientos|${isReturning ? "ida" : "vuelta"}`,
      item_list_name: "Asientos | IS",
      item_variant: _createVariantSeatsString(objVar),
      index: indexing,
      price: promPricePerItem,
      quantity: seats.length,
      cabin: "economy",
    };
  });

  const luggagesCabin = itineraryParts.map((flight) => {
    const isReturning = flight.segments[0].origin === origin;
  
    let ancArr = [];
    const objVariant = {};
  
    const processedAncillaries = new Set();
  
    for (const anc of additionalServicesTemp?.ancillaryOperations) {
      for (const segment of flight.segments) {
        const firstOrigin = flight.segments[0].origin;
        const lastDestination = flight.segments[flight.segments.length - 1].destination;
  
        objVariant[segment.flight.flightNumber] = objVariant[segment.flight.flightNumber] || 0;
  
        if (
          anc.selectedTravelPart.origin === firstOrigin &&
          anc.selectedTravelPart.destination === lastDestination &&
          anc.ancillaryCode === "07X" &&
          !processedAncillaries.has(anc.ancillaryCode)
        ) {
          ancArr.push(anc);
          objVariant[segment.flight.flightNumber] += anc.selectedPassengers.reduce(
            (total, item) => total + item.quantity,
            0
          );
          processedAncillaries.add(anc.ancillaryCode);
        }
      }
    }
  
    let qtyAdditionalByFare = 0;
    let objVariantByFare = {};
  
    const totalQuantity = ancArr.reduce(
      (acc, anc) =>
        acc +
        anc.selectedPassengers.reduce((acc, anc) => acc + anc.quantity, 0),
      0
    );
  
    const totalPrice = ancArr.reduce(
      (acc, anc) =>
        acc + anc.ancInfo.baseAmount * anc.selectedPassengers.length,
      0
    );
  
    const promPricePerItem = totalQuantity > 0 ? totalPrice / totalQuantity : 0;
  
    return {
      item_id: `${originDestination} | Maletas_cabina`,
      item_name: "Maletas_cabina",
      item_category: `Maletas_cabina|${isReturning ? "ida" : "vuelta"}`,
      item_list_name: "Maletas_cabina | IS",
      item_variant: _createVariantString(
        _mergeCoutingObjects(objVariant, objVariantByFare)
      ),
      index: indexing,
      price: promPricePerItem,
      quantity: totalQuantity,
      cabin: "economy",
    };
  });

  const luggagesHold = itineraryParts.map((flight) => {
    const isReturning = flight.segments[0].origin === origin;
  
    let ancArr = [];
    const objVariant = {};
  
    const processedAncillaries = new Set();
  
    for (const anc of additionalServicesTemp?.ancillaryOperations) {
      for (const segment of flight.segments) {
        const firstOrigin = flight.segments[0].origin;
        const lastDestination = flight.segments[flight.segments.length - 1].destination;
  
        objVariant[segment.flight.flightNumber] =
          objVariant[segment.flight.flightNumber] || 0;

        if (
          anc.selectedTravelPart.origin === firstOrigin &&
          anc.selectedTravelPart.destination === lastDestination &&
          ["0GO", "0FA", "0GP"].includes(anc.ancillaryCode) &&
          !processedAncillaries.has(anc.ancillaryCode)
        ) {
          ancArr.push(anc);
          objVariant[segment.flight.flightNumber] += anc.selectedPassengers.reduce(
            (total, item) => total + item.quantity,
            0
          );
          processedAncillaries.add(anc.ancillaryCode);
        }
      }
    }
  
    let objVariantByFare = {};
  
    const totalQuantity = ancArr.reduce(
      (acc, anc) =>
        acc +
        anc.selectedPassengers.reduce((acc, anc) => acc + anc.quantity, 0),
      0
    );
  
    const totalPrice = ancArr.reduce(
      (acc, anc) =>
        acc + anc.ancInfo.baseAmount * anc.selectedPassengers.length,
      0
    );
  
    const promPricePerItem = totalQuantity > 0 ? totalPrice / totalQuantity : 0;
  
    return {
      item_id: `${originDestination} | Maletas_bodega`,
      item_name: "Maletas_bodega",
      item_category: `Maletas_bodega|${isReturning ? "ida" : "vuelta"}`,
      item_list_name: "Maletas_bodega | IS",
      item_variant: _createVariantString(
        _mergeCoutingObjects(objVariant, objVariantByFare)
      ),
      index: indexing,
      price: promPricePerItem,
      quantity: totalQuantity,
      cabin: "economy",
    };
  });

  const othersAnc = itineraryParts.map((flight) => {
    const isReturning = flight.segments[0].origin === origin;
  
    const ancArr = [];
    const objVariant = {};
    
    const processedAncillaries = new Set();
  
    for (const anc of additionalServicesTemp?.ancillaryOperations) {
      const nameAnc = ANC_BY_ID[anc.ancillaryCode];
      const firstOrigin = flight.segments[0].origin;
      const lastDestination = flight.segments[flight.segments.length - 1].destination;
  
      objVariant[nameAnc] = objVariant[nameAnc] || 0;

      if (
        anc.selectedTravelPart.origin === firstOrigin &&
        anc.selectedTravelPart.destination === lastDestination &&
        !processedAncillaries.has(anc.ancillaryCode) &&
        !["07X", "0B5", "0GO", "0FA", "0GP"].includes(anc.ancillaryCode)
      ) {
        ancArr.push(anc);
        objVariant[nameAnc] += anc.selectedPassengers.reduce(
          (total, item) => total + item.quantity,
          0
        );
        processedAncillaries.add(anc.ancillaryCode);
      }
    }
  
    let totalAmountCabin = 0;
    let totalQtyCabin = 0;
    ancArr.forEach((ancillary) => {
      const { totalAmount, totalQuantity } =
        _calculateTotalAmountAndQuantity(ancillary);
      totalAmountCabin += totalAmount;
      totalQtyCabin += totalQuantity;
    });
  
    const promPricePerItem = totalQtyCabin > 0 ? totalAmountCabin / totalQtyCabin : 0;
  
    return {
      item_id: `${originDestination} | Otros_servicios`,
      item_name: "Otros_servicios",
      item_category: `Otros_servicios|${isReturning ? "ida" : "vuelta"}`,
      item_list_name: `Otros_servicios/${isReturning ? "ida" : "vuelta"} | IS`,
      item_variant: _createVariantString(objVariant),
      index: indexing,
      price: promPricePerItem,
      quantity: totalQtyCabin,
      cabin: "economy",
    };
  });

  return [
    ...tickets,
    ...seats,
    ...luggagesCabin,
    ...luggagesHold,
    ...othersAnc,
  ].filter((item) => item.quantity > 0);
};
